module.exports = __webpack_public_path__ + "img/CPM.49580cbe.svg";